import { IndicatorProduct } from '@/api/rest/resources/types/IndicatorProduct';
import { useIndicatorProduct } from '@/hooks/useIndicatorProduct';

export const useNewIndicatorProducts = (): IndicatorProduct[] => {
  return useIndicatorProduct({
    purchased: false,
    visible_for_customer: true,
  }).data;
};

export const useSelectedIndicatorProducts = (): IndicatorProduct[] => {
  return useIndicatorProduct({
    purchased: true,
    visible_for_customer: true,
  }).data;
};
